import { render } from "./TenantItem.vue?vue&type=template&id=231a8c68"
import script from "./TenantItem.vue?vue&type=script&lang=js"
export * from "./TenantItem.vue?vue&type=script&lang=js"

import "./TenantItem.vue?vue&type=style&index=0&id=231a8c68&lang=css"
script.render = render

export default script